import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'moveSelections',
        (state.get('moveSelections') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, { errors }) {
    return state.set(
        'moveSelections',
        (state.get('moveSelections') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );
}

export function finish(state) {
    return state
        .set(
            'moveSelections',
            (state.get('moveSelections') || Map())
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}